const favorites = {
  favorites: {
    title: 'My Favorites',
    subtitle: '{{count}} properties saved in {{listCount}} lists',
    lists: {
      title: 'Lists',
      newList: 'New List',
      defaultName: 'Favorites',
      editList: 'Edit List',
      deleteList: 'Delete List',
      deleteConfirm: "Delete '{{name}}'? This cannot be undone.",
      deleteWarning: 'All properties will be moved to the default list',
      propertyCount: '{{count}} properties',
      propertyCountSingular: '1 property',
      createPlaceholder: 'e.g., To Visit',
      name: 'List Name',
      color: 'Color',
      icon: 'Icon',
    },
    recentlySaved: {
      title: 'Recently Saved',
      addedAgo: 'Added {{time}}',
    },
    empty: {
      title: 'No saved properties',
      description: 'Start browsing properties to add favorites',
      cta: 'Browse Properties',
      listEmpty: 'No properties in this list',
    },
    listPicker: {
      title: 'Save to List',
      addToList: 'Add to {{name}}',
      inList: 'In {{name}}',
      createNew: 'Create New List',
      remove: 'Remove from all lists',
      propertyCount: '{{count}} properties',
      propertyCount_one: '{{count}} property',
      addedToList: 'Added to list',
      removedFromList: 'Removed from list',
      error: 'Failed to update list',
      newListPlaceholder: 'Enter list name',
      cancel: 'Cancel',
      create: 'Create',
      listCreated: 'List "{{name}}" created',
      createError: 'Failed to create list',
    },
    toast: {
      saved: 'Saved to {{name}}',
      removed: 'Removed from favorites',
      listCreated: 'List "{{name}}" created',
      listUpdated: 'List updated',
      listDeleted: 'List deleted',
      bulkRemoved: '{{count}} properties removed',
    },
    hint: {
      tapToSave: 'Tap to save',
      dismiss: 'Got it',
    },
    selection: {
      selectMode: 'Select',
      selected: '{{count}} selected',
      removeSelected: 'Remove Selected',
      cancel: 'Cancel',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
    },
    viewModes: {
      grid: 'Grid',
      list: 'List',
    },
    actions: {
      viewDetails: 'View Details',
      remove: 'Remove',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      create: 'Create',
      saveChanges: 'Save Changes',
    },
    loading: 'Loading...',
  },
};

export default favorites;
